@import '../../shared';

:host {
  display: block;
  overflow: hidden;
}

header {
  background-color: var(--sfc-menu-color-background);
}

div.section-header {
  box-sizing: border-box;
  border-bottom: 1px solid var(--sfc-color-border-default);
  margin-right: 0;
}

div.sfc-select--state-selected {
  margin: 4px 0 0 0;
}

.language-selector {
  float: right;
}

button.sfc-button.sfc-button--text {
  font-size: var(--sfc-font-size-md);
}

#rabobank-logo {
  height: 24px;
  width: 130px;
}

#page-title {
  color: var(--sfc-paragraph-color-text);
  font-size: 18px;
  font-style: normal;
  font-weight: normal;
  line-height: 48px;
  padding: 0;
}

#source-name-logo {
  height: 24px;
  margin-bottom: -6px;
}

#cancel-button {
  float: right;
}

sfc-select.language-selector {
  position: relative;
  top: var(--sfc-margin-75);
}

@media (min-width: 576px) {
  div.section-header {
    min-height: 73px;
  }

  #rabobank-logo {
    height: 24px;
  }

  #page-title {
    font-size: 21px;
    line-height: 73px;
  }

  #source-name-logo {
    height: 36px;
    vertical-align: text-bottom;
  }

  div.modal-buttons {
    min-height: 0;
  }
}
